import { API, Endpoints } from '@brg/api'

type ChangeTeamSortingParams = {
  teamId: string
  itemsIds: string[]
}

export const changeTeamSorting = ({
  teamId,
  itemsIds,
}: ChangeTeamSortingParams) => (
  API.request()
    .endpoint(Endpoints.geograffee)
    .url('/api/Team/ChangeTeamSorting')
    .post()
    .body({
      teamId,
      itemsIds,
    })
    .send()
)
import { API, Endpoints } from '@brg/api'

type ChangeTeamSortingParams = {
  teamId: string
  itemsIds: string[]
}

export const changeTeamSorting = ({
  teamId,
  itemsIds,
}: ChangeTeamSortingParams) => (
  API.request()
    .endpoint(Endpoints.geograffee)
    .url('/api/Team/ChangeTeamSorting')
    .post()
    .body({
      teamId,
      itemsIds,
    })
    .send()
)
